/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListSubObjectivesByObjectiveQueryResponse, ListSubObjectivesByObjectivePathParams, ListSubObjectivesByObjective400, ListSubObjectivesByObjective401, ListSubObjectivesByObjective403, ListSubObjectivesByObjective404, ListSubObjectivesByObjective409, ListSubObjectivesByObjective500 } from "../../types/planningTasksController/ListSubObjectivesByObjective.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listSubObjectivesByObjective } from "../../client/planningTasksController/listSubObjectivesByObjective.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listSubObjectivesByObjectiveQueryKey = (organizationId: ListSubObjectivesByObjectivePathParams["organizationId"] | undefined, objectiveId: ListSubObjectivesByObjectivePathParams["objectiveId"] | undefined) => [{ url: '/api/organizations/:organizationId/objectives/:objectiveId/sub-objectives', params: {organizationId:organizationId,objectiveId:objectiveId} }] as const

export type ListSubObjectivesByObjectiveQueryKey = ReturnType<typeof listSubObjectivesByObjectiveQueryKey>

export function listSubObjectivesByObjectiveQueryOptions(organizationId: ListSubObjectivesByObjectivePathParams["organizationId"] | undefined, objectiveId: ListSubObjectivesByObjectivePathParams["objectiveId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listSubObjectivesByObjectiveQueryKey(organizationId, objectiveId)
        return queryOptions<ListSubObjectivesByObjectiveQueryResponse, ResponseErrorConfig<ListSubObjectivesByObjective400 | ListSubObjectivesByObjective401 | ListSubObjectivesByObjective403 | ListSubObjectivesByObjective404 | ListSubObjectivesByObjective409 | ListSubObjectivesByObjective500>, ListSubObjectivesByObjectiveQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && objectiveId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listSubObjectivesByObjective(organizationId!, objectiveId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List sub-objectives by objective
 * {@link /api/organizations/:organizationId/objectives/:objectiveId/sub-objectives}
 */
export function useListSubObjectivesByObjective<TData = ListSubObjectivesByObjectiveQueryResponse, TQueryData = ListSubObjectivesByObjectiveQueryResponse, TQueryKey extends QueryKey = ListSubObjectivesByObjectiveQueryKey>(organizationId: ListSubObjectivesByObjectivePathParams["organizationId"] | undefined, objectiveId: ListSubObjectivesByObjectivePathParams["objectiveId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ListSubObjectivesByObjectiveQueryResponse, ResponseErrorConfig<ListSubObjectivesByObjective400 | ListSubObjectivesByObjective401 | ListSubObjectivesByObjective403 | ListSubObjectivesByObjective404 | ListSubObjectivesByObjective409 | ListSubObjectivesByObjective500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listSubObjectivesByObjectiveQueryKey(organizationId, objectiveId)
         

         const query = useQuery({
          ...listSubObjectivesByObjectiveQueryOptions(organizationId, objectiveId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListSubObjectivesByObjective400 | ListSubObjectivesByObjective401 | ListSubObjectivesByObjective403 | ListSubObjectivesByObjective404 | ListSubObjectivesByObjective409 | ListSubObjectivesByObjective500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}